/**
 * Dynamic configuration available for the browser and server populated from your `next.config.mjs`.
 * Note: requires `ssr: true` or a `getInitialProps` in `_app.tsx`
 * @link https://nextjs.org/docs/api-reference/next.config.js/runtime-configuration
 */
import type * as config from "../../next.config.js";
import getConfig from "next/config";

/**
 * Inferred type from `publicRuntime` in `next.config.mjs`
 */
type PublicRuntimeConfig = typeof config.publicRuntimeConfig;

const nextConfig = getConfig();

const unitTestConfig: PublicRuntimeConfig = {
  APP_ENV: "test",
  NODE_ENV: "development",
  APP_VERSION: "test",
};

export const publicRuntimeConfig = process.env.VITEST
  ? unitTestConfig
  : (nextConfig.publicRuntimeConfig as PublicRuntimeConfig);
